import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { ReorderDeliveryPriorityPayload } from "../../deliveryPriority.types";
import { requestReorderDeliveryPriority } from "./reorderDeliveryPriority.request";

const useReorderDeliveryPriority = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: (payload: ReorderDeliveryPriorityPayload) =>
      requestReorderDeliveryPriority(payload),
    ...options
  });
};

export default useReorderDeliveryPriority;
